import { render } from "./AuthorizedContactRow.vue?vue&type=template&id=1010404c&ts=true"
import script from "./AuthorizedContactRow.ts?vue&type=script&lang=ts&external"
export * from "./AuthorizedContactRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__